import { IbContestInternalResultsKey } from 'api/Trading-Accounts/Types/MarketingCampaignResultsDto'

import { GridColumn } from './CampaignDetailsResultsPage'

const campaignDetailsResultsColumn: GridColumn[] = [
  {
    title: 'Ranking',
    field: IbContestInternalResultsKey.ranking,
    show: true,
    className: 'table-columns__content',
    filterable: true,
    sortable: true,
    filter: 'text',
  },
  {
    title: 'IB code',
    field: IbContestInternalResultsKey.ibCode,
    show: true,
    className: 'table-columns__content',
    filterable: true,
    sortable: false,
    filter: 'text',
  },
  {
    title: 'Client Name',
    field: IbContestInternalResultsKey.clientName,
    show: true,
    className: 'table-columns__content',
    sortable: true,
    filterable: true,
    filter: 'text',
  },

  {
    title: 'Country',
    field: IbContestInternalResultsKey.country,
    show: true,
    className: 'table-columns__content',
    sortable: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Client Count',
    field: IbContestInternalResultsKey.clientsCount,
    show: true,
    className: 'table-columns__content',
    sortable: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Contest Points',
    field: IbContestInternalResultsKey.contestPoints,
    show: true,
    className: 'table-columns__content',
    sortable: true,
    filterable: true,
    filter: 'text',
  },
]

export default campaignDetailsResultsColumn
